import React from "react";
import { Col, Row } from "react-bootstrap";
import { CgCPlusPlus } from "react-icons/cg";
import "../../skills.css";

import {
  DiJavascript1,
  DiReact,
  DiNodejs,
  DiMongodb,
  DiPython,
  DiGit,
} from "react-icons/di";
import {
  SiPytorch,
  SiFirebase,
  SiNextdotjs,
  SiSpring,
  SiJquery,
  SiMysql,
  SiSqlite,
  SiPostgresql,
  SiDrupal,
  SiDotnet,
  SiAndroidstudio
} from "react-icons/si";
 import {
  DiSymfonyBadge,
  DiLaravel,
  DiPhp,
  DiJava
 } from "react-icons/di";

 import {
  FaDocker,
 } from "react-icons/fa";

 import {
  FiFigma
 } from 'react-icons/fi'


function Techstack() {
  return (
    <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>

      <Col xs={4} md={2} className="tech-icons" title="Symfony">
        <DiSymfonyBadge />
      </Col>

      <Col xs={4} md={2} className="tech-icons" title="Symfony" id="laravel">
        <DiLaravel />
      </Col>


      <Col xs={4} md={2} className="tech-icons" title="PHP" id="php">
        <DiPhp />
      </Col>
      
      <Col xs={4} md={2} className="tech-icons" title="Drupal" id="drupal">
        <SiDrupal />
      </Col>
      <Col xs={4} md={2} className="tech-icons" title="Spring" id="spring">
        <SiSpring />
      </Col>
      <Col xs={4} md={2} className="tech-icons" title="DotNet" id="dotnet">
        <SiDotnet />
      </Col>
      
      <Col xs={4} md={2} className="tech-icons" title="JavaScript" id="js">
        <DiJavascript1 />
      </Col>

      <Col xs={4} md={2} className="tech-icons" title="NodeJs" id="node">
        <DiNodejs />
      </Col>

      <Col xs={4} md={2} className="tech-icons" title="ReactJs" id="react">
        <DiReact />
      </Col>

      <Col xs={4} md={2} className="tech-icons" title="JQuery" id="jquery">
        <SiJquery />
      </Col>


      <Col xs={4} md={2} className="tech-icons" title="JavaFX" id="javafx">
        <DiJava />
      </Col>

      <Col xs={4} md={2} className="tech-icons" title="Android Studio" id="andoidstudio">
        <SiAndroidstudio />
      </Col>

      <Col xs={4} md={2} className="tech-icons" title="Figma" id="figma">
        <FiFigma />
      </Col>
      

      <Col xs={4} md={2} className="tech-icons" title="MySQL" id="mysql">
        <SiMysql />
      </Col>
      
      <Col xs={4} md={2} className="tech-icons" title="SQLite" id="sqlite">
        <SiSqlite />
      </Col>

      <Col xs={4} md={2} className="tech-icons" title="PostgreSQL" id="postgresql">
        <SiPostgresql />
      </Col>

      <Col xs={4} md={2} className="tech-icons" title="MangoDB" id="mongodb" >
        <DiMongodb />
      </Col>

      
      <Col xs={4} md={2} className="tech-icons" title="Git" id="git">
        <DiGit />
      </Col>

      <Col xs={4} md={2} className="tech-icons" title="Docker" id="docker">
        <FaDocker/>
      </Col>


    </Row>
  );
}

export default Techstack;
